import http from './httpService';
import { apiContactForm } from '../config.json';

export function postContactFormData(data) {
	return http.post(apiContactForm, data, {
		headers: {
			'Content-Type': 'application/json',
		},
	});
}
